/// <reference path="./types.d.ts" />

import 'katex/dist/katex.min.css';
import './styles.css';
